/**
 * Open-Iti Exports business service
 */
angular.module("exploitation").factory("OpenExportsService", [
	"$http", "ENV", "$interval", "$rootScope", "CONSTANTS", "toastr",
	function ($http, ENV, $interval, $rootScope, CONSTANTS, toastr) {

	const api = {
		getAllExports: getAllExports,
		getExportsByType:getExportsByType,
		getStopPlaceFileList: getStopPlaceFileList,
		getParkingsFileList: getParkingsFileList,
		getPOIFileList: getPOIFileList,
		getStopPlaceFile:getStopPlaceFile,
		deleteExport: deleteExport,
		postGtfsExport: postGtfsExport,
		postNeptuneExport: postNeptuneExport,
		postNetexExport: postNetexExport,
		getExportDataFile: getExportDataFile,
		getActionReport: getActionReport,
		getValidationReport: getValidationReport,
		getExport: getExport,
		getOkinaJobStatus: getOkinaJobStatus,
		getStopPlacesExportFile: getStopPlacesExportFile,
		getOfferExportFile: getOfferExportFile,
		getLatestExport : getLatestExport,
		getAllGlobalExports: getAllGlobalExports,
		getExportToConsumerEventByJobs: getExportToConsumerEventByJobs,
		getChouetteJobDetail: getChouetteJobDetail,
		getAllTiamatJobByType: getAllTiamatJobByType,
		getLatestSuccessfulTiamatJobByType: getLatestSuccessfulTiamatJobByType,
		getExportInfo: getExportInfo,
		getLatestTiamatJobByType: getLatestTiamatJobByType,
		okinaJobStatusChecker: okinaJobStatusChecker,
		validate: validate,
		exportStopPlaces: exportStopPlaces,
		exportParkings: exportParkings,
		exportPointOfInterest: exportPointOfInterest,
		exportNetex: exportNetex,
		exportNeptune: exportNeptune,
		exportNetexForSimulation: exportNetexForSimulation,
		exportGtfs: exportGtfs,
		exportConcerto: exportConcerto,
		jobCheckerFunctions: {},
		exportAll: exportAll,
		exportById:exportById,
		getAllExportsConcerto: getAllExportsConcerto,
		getOfferExportConcertoFile: getOfferExportConcertoFile,
		getNetexFaresExportFile: getNetexFaresExportFile,
		getAllFareExports: getAllFareExports,
		exportFares: exportFares,
		getNextScheduledNetexFaresExportDate: getNextScheduledNetexFaresExportDate,
		scheduleNetexFaresExport: scheduleNetexFaresExport,
		getFaresExportInfo: getFaresExportInfo,
		mapJobStateToExportStatus: mapJobStateToExportStatus
	};


	function okinaJobStatusChecker(referential, jobId) {
		if (!api.jobCheckerFunctions[jobId]) {
			api.jobCheckerFunctions[jobId] = $interval(function () {
				getOkinaJobStatus(jobId).then(function (status) {
					if (status !== "STARTED") {
						$interval.cancel(api.jobCheckerFunctions[jobId]);
						$rootScope.$broadcast(CONSTANTS.EVENT_EXPORT_COMPLETE);
						toastr.success("<a href=\"#/data-management/exports/" + referential + "/" + jobId + "\">Cliquez ici pour accéder au résultat de l'export</a>", "Export terminé", {allowHtml: true});
						api.jobCheckerFunctions[jobId] = undefined;
					}
				});
			}, 5000);
		}
	}


	/**
	 * Récupérer le statut d'un job Okina.
	 * Job okina englobe job IEV + actions sépcifiques Okina (MAJ BDD) suite à l'export.
	 * @param jobId
	 */
	function getOkinaJobStatus(jobId) {
		return $http.get(ENV.API_URL + "/exports/" + jobId + "/okinaJobStatus");

	}

	/**
	 * Récupérer le fichier d'export pour un job.
	 * @param referential
	 * @param jobId
	 * @param fileName
	 * @returns {*}
	 */
	function getExportDataFile(referential, jobId, fileName) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/" + fileName, {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}

	/**
	 * Récupérer le rapport d'action pour un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getActionReport(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/action_report.json");
	}

	/**
	 * Récupérer le rapport de validation pour un job
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getValidationReport(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/data/" + jobId + "/validation_report.json");
	}

	/**
	 * Récupérer le détail d'un export.
	 *
	 * @deprecated Okina backend is not up to date to marshall data
	 *
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getExport(referential, jobId) {
		return $http.get(ENV.API_URL + "/exports/" + referential + "/" + jobId);
	}

	/**
	 * Récupérer le détail d'un export réalisé par chouette.
	 * @param referential
	 * @param jobId
	 * @returns {*}
	 */
	function getChouetteJobDetail(referential, jobId) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/one-job/" + jobId);
	}

	/**
	 * Récupérer le status d'un export réalisé par Tiamat.
	 * @param referential
	 * @param exportType
	 * @returns {*}
	 */
	function getLatestTiamatJobByType(exportType) {
		return $http.get(ENV.TIAMAT_BASE_URL + "/jobs/exports/latest?jobType=" + exportType,
			{
				headers: {
					"x-okina-referential": 'technique'
				}
			});
	}

	/**
	 * Récupérer le dernier export OK de Tiamat.
	 * @param referential
	 * @param exportType
	 * @returns {*}
	 */
	function getLatestSuccessfulTiamatJobByType(exportType) {
		return $http.get(ENV.TIAMAT_BASE_URL + "/jobs/exports/latest?jobStatus=FINISHED&jobType=" + exportType,
			{
				headers: {
					"x-okina-referential": 'technique'
				}
			});
	}

	function getAllTiamatJobByType(exportType) {
		return $http.get(ENV.TIAMAT_BASE_URL + "/jobs/exports?jobType=" + exportType,
			{
				headers: {
					"x-okina-referential": 'technique'
				}
			});
	}

	/**
	 * Récupérer tous les exports
	 *
	 * @returns {*}
	 */
	function getAllExports(refId) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + refId
			+ "?actionType=EXPORTER&action=EXPORT&action=EXPORT_NETEX", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	function getAllGlobalExports(referentialId, actionFilter) {
		const urlFilter = "?" + actionFilter.map(item => "action="+item).join("&");
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + referentialId
			+ urlFilter, {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	function getExportToConsumerEventByJobs(referentialId, actionFilter, jobsId) {
		const urlFilter = "?" + actionFilter.map(item => "action="+item).join("&");
		const jobsFilter = "&" + jobsId.map(jobId => "chouetteJobId="+jobId).join("&");
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + referentialId
			+ urlFilter + jobsFilter, {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	/**
	 * Récupérer les informations d'export en fonction des paramètres passés en argument.
	 * @param providerId
	 * @param queryParams
	 * @returns {*}
	 */
	function getExportInfo(providerId, queryParams) {
		let strQueryParams = "";
		if (queryParams) {
			strQueryParams = "?" + Array.from(queryParams)
				.map(([key, value]) => `${key}=${value}`)
				.join('&');
		}
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + providerId + strQueryParams);
	}


	/**
	 * Récupérer les exports d'un type
	 *
	 * @returns {*}
	 */
	function getExportsByType(refId, exportType,maxResults) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/getExports/" + refId
			+ "?exportType="+exportType + "&maxResults="+maxResults, {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	/**
	 * Récupérer tous les exports Concerto
	 *
	 * @returns {*}
	 */
	function getAllExportsConcerto() {
		return $http.get(ENV.API_URL + "/exports/concerto");
	}

	/**
	 * Récupérer la liste des exports NeTex Arrets
	 * @param providerName
	 * @param mxNbResults
	 * @returns {*}
	 */
	function getStopPlaceFileList(providerName, maxNbResults) {
		return $http.get(ENV.TIAMAT_BASE_URL + "netex/export/stop-place-summary/" + providerName, {
			headers: {
				"maxNbResults": maxNbResults
			}
		});
	}

	/**
	 * Récupérer la liste des exports NeTex POI
	 * @param providerName
	 * @param mxNbResults
	 * @returns {*}
	 */
	function getParkingsFileList(providerName, maxNbResults) {
		return $http.get(ENV.TIAMAT_BASE_URL + "netex/export/parkings-file-list-by-provider-name/"+providerName, {
			headers: {
				"maxNbResults": maxNbResults
			}
		});
	}

	/**
	 * Récupérer la liste des exports NeTex POI
	 * @param providerName
	 * @param mxNbResults
	 * @returns {*}
	 */
	function getPOIFileList(providerName, maxNbResults) {
		return $http.get(ENV.TIAMAT_BASE_URL + "netex/export/poi-file-list-by-provider-name/"+providerName, {
			headers: {
				"maxNbResults": maxNbResults
			}
		});
	}

	/**
	 * Récupérer un fichier d'arrets NeTex spécifique
	 * @param providerName
	 * @param fileName
	 * @returns {*}
	 */
	function getStopPlaceFile(providerName, fileName) {
		return $http.get(ENV.TIAMAT_BASE_URL + "netex/export/stop-place-file-download/"+providerName+"/"+fileName, {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}

	/**
	 * Démarrer un job d'export.
	 * @param exportData
	 * @returns {*|HttpPromise}
	 */
	function postGtfsExport(exportData) {

		let fd = {};
		if (angular.isDefined(exportData.name)) {
			fd["name"] = exportData.name;
		}
		if (angular.isDefined(exportData.referencetype)) {
			fd["referencetype"] = exportData.referencetype;
		}
		if (angular.isDefined(exportData.ids)) {
			fd["reference_ids"] = exportData.ids;
		}
		if (angular.isDefined(exportData.timezone)) {
			fd["timezone"] = exportData.timezone;
		}
		if (angular.isDefined(exportData.startdate && exportData.startdate !== null)) {
			fd["startdate"] = exportData.startdate;
		}
		if (angular.isDefined(exportData.enddate && exportData.enddate !== null)) {
			fd["enddate"] = exportData.enddate;
		}
		return $http.post(ENV.API_URL + "/exports/gtfs", fd);

	}

	/**
	 * Démarrer un job d'export Neptune.
	 * @param exportData
	 * @returns {*|HttpPromise}
	 */
	function postNeptuneExport(exportData) {

		let fd = new FormData();
		if (exportData.name !== undefined) {
			fd.append("name", exportData.name);
		}
		if (exportData.referencetype !== undefined) {
			fd.append("referencetype", exportData.referencetype);
		}
		if (exportData.ids !== undefined) {
			fd.append("reference_ids", exportData.ids);
		}
		if (exportData.startdate !== undefined && exportData.startdate !== null) {
			fd.append("startdate", exportData.startdate.getDate() + "-" + (exportData.startdate.getMonth() + 1) + "-" + exportData.startdate.getFullYear());
		}
		if (exportData.enddate !== undefined && exportData.enddate !== null) {
			fd.append("enddate", exportData.enddate.getDate() + "-" + (exportData.enddate.getMonth() + 1) + "-" + exportData.enddate.getFullYear());
		}

		return $http.post(ENV.API_URL + "/exports/neptune", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});
	}


	/**
	 * Démarrer un job d'export Netex.
	 * @param exportData
	 * @returns {*|HttpPromise}
	 */
	function postNetexExport(exportData) {

		let fd = new FormData();
		if (exportData.name !== undefined) {
			fd.append("name", exportData.name);
		}
		if (exportData.referencetype !== undefined) {
			fd.append("referencetype", exportData.referencetype);
		}
		if (exportData.ids !== undefined) {
			fd.append("reference_ids", exportData.ids);
		}
		if (exportData.startdate !== undefined && exportData.startdate !== null) {
			fd.append("startdate", exportData.startdate.getDate() + "-" + (exportData.startdate.getMonth() + 1) + "-" + exportData.startdate.getFullYear());
		}
		if (exportData.enddate !== undefined && exportData.enddate !== null) {
			fd.append("enddate", exportData.enddate.getDate() + "-" + (exportData.enddate.getMonth() + 1) + "-" + exportData.enddate.getFullYear());
		}

		return $http.post(ENV.API_URL + "/exports/netex", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});
	}


	/**
	 * Supprimer un export.
	 *
	 * @returns {*}
	 */
	function deleteExport(exportToDelete) {
		return $http.delete(ENV.API_URL + "/exports/" + exportToDelete.referential + "/" + exportToDelete.id);
	}

	function validate(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/validate", {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	function exportStopPlaces(providerId, user, exportGeneratedMissingQuays, exportExternalIds) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/stops", {
			headers: {
				Accept: "application/json",
				"RutebankenUser": user,
				"exportGeneratedMissingQuays": exportGeneratedMissingQuays,
				"exportExternalIds": exportExternalIds
			}
		});
	}

	function exportParkings(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/parkings", {
			headers: {
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	function exportPointOfInterest(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/poi", {
			headers: {
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	function exportNetex(providerId, user, exportGeneratedMissingQuays, exportExternalIds) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/netex", {
			headers: {
				Accept: "application/json",
				"RutebankenUser": user,
				"exportGeneratedMissingQuays": exportGeneratedMissingQuays,
				"exportExternalIds": exportExternalIds
			}
		});
	}

	function exportNeptune(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/neptune", {
			headers: {
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	function exportNetexForSimulation(parentProvider, user, exportName) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + parentProvider + "/export/netex_simulation", {
			headers: {
				Accept: "application/json",
				"RutebankenUser" : user,
				"exportSimulationName" : exportName
			}
		});
	}

	function exportGtfs(providerId, user, exportData) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/gtfs", {
			headers: {
				"EXPORT_LINES_IDS" : exportData.ids,
				"EXPORT_START_DATE" : exportData.startdate.getTime(),
				"EXPORT_END_DATE" : exportData.enddate.getTime(),
				"EXPORT_NAME" : exportData.name,
				"EXPORT_ATTRIBUTIONS" : exportData.attributionsExport,
				"ID_FORMAT" : exportData.idFormat,
				"GOOGLE_MAPS_COMPATIBILITY" : exportData.exportCompatibleWithGoogleMaps,
				"ID_SUFFIX" : exportData.idSuffix,
				"COMMERCIAL_POINT_ID_PREFIX" : exportData.commercialPointIdPrefix,
				"COMMERCIAL_POINT_EXPORT" : !exportData.exportWithCommercialPoints,
				"EXPORTED_FILENAME" : exportData.exportedFileName,
				"STOP_ID_PREFIX" : exportData.stopIdPrefix,
				"LINE_ID_PREFIX" : exportData.lineIdPrefix,
				"EXPORT_ALL_LINES" : exportData.exportAllLines,
				"USE_EXTENDED_GTFS_ROUTE_TYPES": exportData.useExtendedGtfsRouteTypes,
				"faresIncluded": exportData.includeFares,
				"includeFlex": exportData.includeFlex,
				"Content-Type": "application/json",
				Accept: "application/json",
				"RutebankenUser": user
			}
		});

	}

	function exportConcerto(providerId, user, exportData) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/concerto", {
			headers: {
				"EXPORT_START_DATE" : exportData.startdate != null ? exportData.startdate.getTime() : null,
				"EXPORT_END_DATE" : exportData.enddate != null ? exportData.enddate.getTime() : null,
				"OBJECT_TYPE_CONCERTO" : exportData.objectTypeConcerto,
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}


	function exportAll(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export/all", {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	function exportById(providerId, user, id) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/export-by-id/" + id, {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				"RutebankenUser": user
			}
		});
	}

	/**
	 * Récupère le dernier fichier export Netex arrêts.
	 * @param providerId
	 * @returns {*}
	 */
	function getStopPlacesExportFile(providerId) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/files/stop-places", {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}

	/**
	 * Récupère un fichier export GTFS, Netex selon le jobId
	 * @param providerId
	 * @param jobId
	 * @returns {*}
	 */
	function getOfferExportFile(providerId, jobId) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/files/offer/" + jobId, {
			responseType: "arraybuffer",
			headers: {
				"Content-Type": "application/octet-stream"
			}
		});
	}



	function getLatestExport(refId) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + refId
			+ "?actionType=EXPORTER&state=OK&latest=true", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

		/**
		 * Récupère un fichier Concerto selon le jobId dans admin
		 * @param providerId
		 * @param jobId
		 * @returns {*}
		 */
		function getOfferExportConcertoFile(providerId, jobId) {
			return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/files/offer/concerto/" + jobId, {
				responseType: "arraybuffer",
				headers: {
					"Content-Type": "application/octet-stream"
				}
			});
		}

		function getNetexFaresExportFile(jobId) {
			return $http.get(`${ENV.FARES_BASE_URL}fares-referential/fares/export/${jobId}/file`,  {
				responseType: 'arraybuffer'
			});
		}

		function getAllFareExports(limit) {
			return $http.get(`${ENV.FARES_BASE_URL}fares-referential/fares/export?limit=${limit}`, {
				transformRequest: angular.identity
			});
		}

		function exportFares(providerId, user) {
			return $http.post(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/export/netexFares`, {
				headers: {
					"RutebankenUser": user,
				}
			});
		}

		function getNextScheduledNetexFaresExportDate(providerId) {
			return $http.get(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/export/netexFares/schedule`);
		}

		function scheduleNetexFaresExport(providerId, user, scheduleDate) {
			return $http.post(`${ENV.TIMETABLE_ADMIN_BASE_URL}${providerId}/export/netexFares/schedule`,
				{
					when: scheduleDate
				},
				{
					headers: {
						"Content-Type": "application/json",
						"RutebankenUser": user,
					}
				}
			);
		}

		function getFaresExportInfo(location) {
			return $http.post(ENV.FARES_BASE_URL + location, {
				transformRequest: angular.identity
			});
		}

		function mapJobStateToExportStatus (jobState) {
			switch(jobState) {
			case "FINISHED":
			case "OK":
			case "TERMINATED":
				return "Terminé";
			case "PROCESSING":
			case "STARTED":
				return "En cours";
			case "FAILED":
				return "Échoué";
			default:
				return "Inconnu";
			}
		}

		return api;
	}]
);
